export const messages = {
  appLoadingMessage: 'Laster inn dataleverandører og organisasjoner...',
  exportsLoadExportByIdErrorHeader: 'Laste eksport',
  exportsLoadExportByIdErrorMessage:
    'En feil oppstod under lastingen av eksporten: {details}',
  exportsLoadExportsErrorHeader: 'Laste eksporter',
  exportsLoadExportsErrorMessage:
    'En feil oppstod under lastingen av eksportene: {details}',
  exportsSaveExportErrorHeader: 'Lagre eksport',
  exportsSaveExportErrorMessage:
    'En feil oppstod under lagringen av eksporten: {details}',
  exportsSaveExportSuccessHeader: 'Lagre eksport',
  exportsSaveExportSuccessMessage: 'Eksporten ble lagret.',
  deleteLineErrorHeader: 'Slette linje',
  deleteLineErrorMessage:
    'En feil oppstod under slettingen av linjen: {details}',
  deleteLineSuccessHeader: 'Slette linje',
  deleteLineSuccessMessage: 'Linjen ble slettet',
  loadLineByIdErrorHeader: 'Laste linje',
  loadLineByIdErrorMessage:
    'En feil oppstod under lastingen av linjen: {details}',
  loadLinesErrorHeader: 'Laste linjer',
  loadLinesErrorMessage:
    'En feil oppstod under lastingen av linjene: {details}',
  saveLineErrorHeader: 'Lagre linje',
  saveLineErrorMessage: 'En feil oppstod under lagringen av linjen: {details}',
  saveLineSuccessHeader: 'Lagre linje',
  saveLineSuccessMessage: 'Linjen ble lagret!',
  modalSaveLineSuccessHeader: 'Linjen ble opprettet!',
  modalSaveLineSuccessMessage:
    'ble opprettet og lagret. Se eller gjør endringer i oversikten over Linjer. Husk at du må eksportere for at tilbudet skal bli tilgjengelig i reisesøk.',
  flexibleLinesSaveLineSuccessButton: 'Den er grei',
  flexibleStopPlacesDeleteStopPlaceErrorHeader: 'Slette stoppested',
  flexibleStopPlacesDeleteStopPlaceErrorMessage:
    'En feil oppstod under slettingen av stoppestedet: {details}',
  flexibleStopPlacesDeleteStopPlaceSuccessHeader: 'Slette stoppested',
  flexibleStopPlacesDeleteStopPlaceSuccessMessage: 'Stoppestedet ble slettet',
  flexibleStopPlacesLoadStopPlaceErrorHeader: 'Laste stoppested',
  flexibleStopPlacesLoadStopPlaceErrorMessage:
    'En feil oppstod under lastingen av stoppestedet: {details}',
  flexibleStopPlacesLoadStopPlacesErrorHeader: 'Laste stoppesteder',
  flexibleStopPlacesLoadStopPlacesErrorMessage:
    'En feil oppstod under lastingen av stoppestedene: {details}',
  flexibleStopPlacesSaveStopPlaceErrorHeader: 'Lagre stoppested',
  flexibleStopPlacesSaveStopPlaceErrorMessage:
    'En feil oppstod under lagringen av stoppested: {details}',
  flexibleStopPlacesSaveStopPlaceSuccessHeader: 'Lagre stoppested',
  flexibleStopPlacesSaveStopPlaceSuccessMessage: 'Stoppestedet ble lagret.',
  navBarIntroduction: 'Slik kommer du i gang',
  navBarExportsMenuItemLabel: 'Eksporter',
  navBarLinesMenuItemLabel: 'Linjer',
  navBarFlexibleOffersSubMenuHeaderLabel: 'Fleksible tilbud',
  navBarFlexibleLinesMenuItemLabel: 'Fleksible linjer',
  navBarNetworksMenuItemLabel: 'Nettverk',
  navBarBrandingsMenuItemLabel: 'Merkevarer',
  navBarRootLinkLogoAltText: 'Logo',
  navBarStopPlacesMenuItemLabel: 'Fleksible stoppesteder',
  userMenuLogoutLinkText: 'Logg ut',
  userMenuMenuItemTextEnglish: 'English',
  userMenuMenuItemTextLanguage: 'Språk',
  userMenuMenuItemTextNorwegian: 'Norsk',
  userMenuMenuItemTextSwedish: 'Svenska',
  userMenuMenuItemTextFinnish: 'Suomi',
  userMenuMenuItemTextBulgarian: 'Български',
  languagePickerAriaLabel: 'Velg språk',
  navBarDataProvider: 'Velg dataleverandør',
  redirectTitle: 'Endringer er ikke lagret!',
  redirectMessage:
    'Du har gjort endringer som vil gå tapt hvis du forlater siden. Ønsker du å forlate siden?  ',
  redirectYes: 'Ja, forlat siden',
  redirectNo: 'Nei, bli på siden',
  appTitle: 'Nplan',
  exportsCreateExportButtonLabel: 'Opprett eksport',
  defaultOption: 'Vennligst velg',
  exportCreatorDryRunFormLabel: 'Tørrkjøring',
  exportCreatorDryRunFormLabelTooltip:
    'Eksporterer ikke tilbudet til reisesøk, men genererer en NeTEx-fil man kan se på',
  exportCreatorGenerateServiceLinksFormLabel: 'Generer service links',
  exportCreatorGenerateServiceLinksFormLabelTooltip:
    'Genererer service link-geometri mellom stoppesteder',
  exportCreatorIncludeDatedServiceJourneysFormLabel:
    'Generer DatedServiceJourneys',
  exportCreatorIncludeDatedServiceJourneysFormLabelTooltip:
    'Genererer DatedServiceJourneys',
  exportCreatorFromDateFormLabel: 'Fra dato *',
  exportCreatorHeader: 'Opprett eksport',
  exportCreatorDescription:
    'Eksportér tilbud, slik at de blir tilgjengelige i reisesøk',
  exportCreatorNameFormLabel: 'Navn *',
  exportCreatorSaveButtonLabelText: 'Opprett eksport',
  exportCreatorSavingOverlayLoaderText: 'Lagrer eksporten...',
  exportCreatorToDateFormLabel: 'Til dato *',
  exportCreatorDateForExport: 'Dato for eksport',
  exportCreatorDateForExportDesc:
    'Eksportér tilbud som har tilgjengelighet innenfor denne perioden',
  exportCreatorLinesForExportHeader: 'Velg linjer som skal eksporteres',
  exportCreatorLinesForExportTableLineHeader: 'Linje',
  exportCreatorLinesForExportTableStatusHeader: 'Status',
  exportCreatorLinesForExportTableAvailabilityHeader: 'Tilgjengelighet',
  validateFormErrorExportFromDateIsAfterToDate:
    'Til-dato må være etter fra-dato',
  validateFormErrorExportNameIsEmpty: 'Navn må fylles ut.',
  exportsDownloadLinkText: 'Last ned',
  exportsDryRunNo: 'Nei',
  exportsDryRunYes: 'Ja',
  exportsHeader: 'Eksporter',
  exportsLoadingExportsText: 'Laster inn eksporter...',
  exportsNoExportsFoundText: 'Ingen eksporter ble funnet.',
  exportsTableHeaderLabelDownload: 'Last ned',
  exportsTableHeaderLabelDryrun: 'Tørrkjøring',
  exportsTableHeaderLabelFromDate: 'Fra dato',
  exportsTableHeaderLabelName: 'Navn',
  exportsTableHeaderLabelStatus: 'Status',
  exportsTableHeaderLabelCreated: 'Tidspunkt',
  exportsTableHeaderLabelToDate: 'Til dato',
  viewerDownloadLabel: 'Last ned eksporterte filer',
  viewerDownloadLinkText: 'Last ned',
  viewerDryRunLabel: 'Tørrkjøring',
  viewerDryRunNo: 'Nei',
  viewerDryRunYes: 'Ja',
  viewerGenerateServiceLinksLabel: 'Generer service links',
  viewerGenerateServiceLinksNo: 'Nei',
  viewerGenerateServiceLinksYes: 'Ja',
  viewerIncludeDatedServiceJourneysLabel: 'Generer DatedServiceJourneys',
  viewerIncludeDatedServiceJourneysNo: 'Nei',
  viewerIncludeDatedServiceJourneysYes: 'Ja',
  NO_VALID_FLEXIBLE_LINES_IN_DATA_SPACE: 'Ingen gyldig linjer i datagrunnlaget',
  failed: 'Feilet',
  in_progress: 'Pågår',
  success: 'Ferdig',
  viewerFromDateLabel: 'Fra dato',
  viewerHeader: 'Eksport',
  viewerLoadingText: 'Laster inn eksport...',
  viewerMessagesLabel: 'Meldinger',
  viewerNameLabel: 'Navn',
  viewerStatusLabel: 'Status',
  viewerToDateLabel: 'Til dato',
  uttuErrorCONSTRAINT_VIOLATION: 'Ikke unikt navn',
  uttuErrorCONSTRAINT_VIOLATION_SERVICE_JOURNEY_UNIQUE_NAME:
    'Service journeyen må ha et unikt navn',
  uttuErrorCONSTRAINT_VIOLATION_LINE_UNIQUE_NAME: 'Linjen må ha et unikt navn',
  uttuErrorCONSTRAINT_VIOLATION_JOURNEY_PATTERN_UNIQUE_NAME:
    'Journey patternet må ha et unikt navn',
  uttuErrorENTITY_IS_REFERENCED:
    'Entiteten kan ikke slettes fordi {noOfLines, number} {noOfLines, plural, one {en annen entitet} other {andre entiteter}} refererer til den.',
  uttuErrorFROM_DATE_AFTER_TO_DATE: 'Fra dato kan ikke være etter til dato',
  uttuErrorMINIMUM_POINTS_IN_SEQUENCE:
    'Reisemønster må ha minimum 2 sekvensielle stoppepunkter.',
  uttuErrorMISSING_OPERATOR: 'Tur eller linje må ha operatør',
  uttuErrorORGANISATION_NOT_VALID_OPERATOR: 'Ugyldig operatør',
  uttuErrorNO_VALID_LINES_IN_DATA_SPACE:
    'Fant ingen gyldige linjer i eksporten',
  uttuErrorFLEXIBLE_LINE_REQUIRES_BOOKING:
    'Fleksible linjer må ha bestillingsinformasjon på linje, journey pattern eller service journey',
  uttuErrorNO_EMPTY_NOTICES: 'Tomme notices er ikke tillatt',
  uttuErrorINVALID_POLYGON:
    'Fleksibelt område har et polygon med ugyldig geometri',
  uttuErrorUNKNOWN: 'Ukjent feil',
  linesCreateFlexibleLineIconButtonLabel: 'Opprett fleksibel linje',
  linesCreateLineIconButtonLabel: 'Opprett rutegående linje',
  linesFlexibleDataCell: 'Flexible',
  bookingInfoHeader: 'Bestillingsinformasjon',
  bookingInfoHelpText: `Bestillingsinformasjon kan legges til på fleksibel linje,
  på et stopp i et journey pattern eller på service journey. Når du legger
  bestillingsinformasjon på flere nivåer, vil stopp overstyre service journey,
  som igjen vil overstyre fleksibel linje.`,
  bookingInfoAddButtonText: 'Legg til',
  bookingInfoRemoveButtonText: 'Fjern',
  bookingInfoShowEditButtonText: 'Vis / redigér',
  bookingInfoSaveButtonText: 'Lagre',
  bookingInfoCancelButtonText: 'Avbryt',
  bookingInfoText: 'Informasjon om hvordan tilbudet kan bestilles.',
  bookingLabel:
    'For enklere bestilling av tilbudet anbefales det å fylle ut Telefon, URL og Merknad.',
  bookingAccessAuthorisedPublic: 'Forhåndsgodkjent',
  bookingAccessPublic: 'Åpen',
  bookingAccessStaff: 'Ansatte',
  bookingAccessSelectionTitle: 'Tilgang',
  bookingLimitTypeNoneRadioButtonLabel: 'Ingen',
  bookingLimitFieldsBookingLimitTypePeriodRadioButtonLabel:
    'Seneste tidspunkt før avreise reisen kan bestilles',
  bookingLimitFieldsBookingLimitTypeTimeRadioButtonLabel:
    'Senest mulige tidspunkt for bestilling',
  bookingLimitFieldsHeaderLabel: 'Bestilles innen',
  bookingMethodCallDriver: 'Ring fører',
  bookingMethodCallOffice: 'Ring kundeservice',
  bookingMethodOnline: 'På nett',
  bookingMethodPhoneAtStop: 'Telefon på stoppested',
  bookingMethodText: 'SMS',
  bookingMethodSelectionTitle: 'Hvordan bestille',
  bookingNoteFieldTitle: 'Merknad',
  bookingNoteRequiredFeedback: 'Merknad må fylles inn.',
  bookingNoteTooltip: 'Informasjon som kan vises sammen med reiseforslaget.',
  purchaseWhenAdvanceAndDayOfTravel: 'Frem til og med samme dag',
  purchaseWhenDayOfTravelOnly: 'Samme dag',
  purchaseWhenUntilPreviousDay: 'Inntil dagen før',
  contactFieldsContactPersonTitle: 'Kontaktperson',
  contactFieldsEmailTitle: 'E-post',
  contactFieldsFurtherDetailsTitle: 'Detaljer',
  contactFieldsPhoneTitle: 'Telefon',
  contactFieldsUrlTitle: 'URL',
  urlOrPhoneMustBeFilled: 'URL eller telefonnummer må utfylles',
  purchaseMomentAfterBoarding: 'Etter ombordstigning',
  purchaseMomentBeforeBoarding: 'Før ombordstigning',
  purchaseMomentOnCheckOut: 'Ved avstigning',
  purchaseMomentOnReservation: 'Ved reservering',
  paymentSelectionTitle: 'Betalingstidspunkt',
  bookingTimeSelectionTitle: 'Kan bestilles',
  editorBookingTabLabel: 'Bestilling',
  bookingValidationError:
    'Bestillingsinformasjon må inneholde informasjon om bestillingstidspunkt',
  editorCreateLineHeader: 'Opprett linje',
  editorDeleteButtonText: 'Slett',
  editorCopyButtonText: 'Kopiér',
  editorDeleteConfirmationDialogCancelButtonText: 'Nei',
  editorDeleteConfirmationDialogConfirmButtonText: 'Ja',
  editorDeleteLineConfirmationDialogMessage:
    'Er du sikker på at du ønsker å slette denne linjen?',
  editorDeleteLineConfirmationDialogTitle: 'Slette linje',
  editorDeleteLineLoadingText: 'Sletter linjen...',
  editorDeleteStopPlaceConfirmationDialogMessage:
    'Er du sikker på at du ønsker å slette dette fleksible stoppestedet?',
  editorDeleteStopPlaceConfirmationDialogTitle: 'Slette fleksibelt stoppested',
  editorDeleteNetworkConfirmationDialogMessage:
    'Er du sikker på at du ønsker å slette dette nettverket?',
  editorDeleteNetworkConfirmationDialogTitle: 'Slette nettverk',
  editorEditLineHeader: 'Rediger linje',
  generalDescriptionFormGroupTitle: 'Beskrivelse',
  generalNameFormGroupTitle: 'Navn *',
  generalNetworkFormGroupTitle: 'Nettverk *',
  generalOperatorFormGroupTitle: 'Operatør *',
  generalVehicleTypeTooltip:
    'Kjøretøytype, referanse til en kjøretøytype i materiellregisteret',
  generalVehicleType: 'Kjøretøytype',
  transportModeTitle: 'Transportgruppe *',
  transportSubModeTitle: 'Transportundergruppe *',
  generalPrivateCodeFormGroupTitle: 'Privat kode',
  generalPrivateCodeInputLabelTooltip:
    'Privat kode er det som kjennetegner linjen internt hos en operatør',
  generalPublicCodeFormGroupTitle: 'Publikumskode {requiredMarker}',
  generalPublicCodeInputLabelTooltip:
    'Publikumskode er det som kjennetegner linjen ut mot publikum',
  generalTypeFormGroupTitle: 'Fleksibel linje-type *',
  typeFormGroupTitleTooltip: 'Les mer om linjetypene',
  editorGeneralTabLabel: 'Generelt',
  generalDrawer: 'Her er en kort beskrivelse av de ulike linjetypene.',
  drawerAria: 'Les mer om de ulike linjetypene.',
  generalDrawerTitle: 'Fleksible linjetyper.',
  flexibleLineType_fixed: 'Fast',
  flexibleLineType_flexibleAreasOnly: 'Kun fleksible områder',
  flexibleLineType_mixedFlexible: 'Blandet',
  flexibleLineType_corridorService: 'Korridortjeneste',
  flexibleLineType_mainRouteWithFlexibleEnds: 'Hovedrute med fleksible ender',
  flexibleLineType_hailAndRideSections: 'Hail and ride-strekninger',
  flexibleLineType_fixedStopAreaWide: 'Fast stopp med områdedekning',
  flexibleLineType_mixedFlexibleAndFixed: 'Blandet fleksibel og fast',
  flexibleLineTypeDrawer_fixed:
    'Fast rute til faste tider, men må forhåndsbestilles for at ruten skal kjøres.',
  flexibleLineTypeDrawer_mainRouteWithFlexibleEnds:
    'Fast rute til faste tider, med mulighet for på-/avstigning på stoppesteder utenfor oppsatt kjøremønster ved bestilling.',
  flexibleLineTypeDrawer_fixedStopAreaWide:
    'Fleksibel rute definert av ett eller flere områder, der hvert område kan ha ulike forhåndsbestemte stopp (møteplass, knutepunkt, kommune-senter, holdeplasser).',
  flexibleLineTypeDrawer_flexibleAreasOnly:
    'Hentes og kjøres til/fra valgfritt sted innenfor et definert område og gitte åpningstider.',
  flexibleLineTypeDrawer_hailAndRideSections:
    'Ruten er definert og har noen faste holdeplasser. Langs bestemte strekninger på ruten kan på-/avstigning skje hvor som helst ved signal til sjåfør.',
  flexibleLineTypeDrawer_mixedFlexible:
    'Ruten kan bestå av både faste stopp og fleksible områder, med åpningstider og faste på-/avstigningstidspunkt.',
  flexibleLineTypeDrawer_corridorService:
    'Tilbudet opererer langs en definert korridor, der passasjerer kan bli hentet og satt av langs ruten.',
  flexibleLineTypeDrawer_mixedFlexibleAndFixed:
    'En kombinasjon av faste stoppesteder og fleksible områder, der noen stopp er faste og andre er fleksible.',
  journeyPatternsAddJourneyPatternIconButtonLabel: 'Legg til journey pattern',
  journeyPatternsUnsavedChanges: 'Du har endringer som ikke er lagret.',
  journeyPatternsSaveAndContinue: 'Lagre og gå videre',
  editorAbout: 'Om linjen',
  editorFillInformation:
    'Et journey pattern definerer linjen eller området for tjenesten, og består av stoppene langs ruten eller området tjenesten opererer innenfor.',
  stepperAbout: 'Om linjen',
  stepperJourneyPattern: 'Journey Patterns',
  stepperServiceJourney: 'Service Journeys',
  stepperBooking: 'Bestillingsinfo',
  editorStopPoints: 'Legg til stopp for tilbudet',
  editorStopPointFlexibleAreaOnly:
    'Legg til fleksibelt stoppested som definerer tilbudet',
  stopPointsInfo:
    'Du må legge til minst to stopp; ett for start og ett for slutt. Velg mellom fleksible stoppesteder eller platform-IDer fra Nasjonalt stoppestedsregister.',
  stopPointsInfoFixed:
    'Du må legge til minst to stopp; ett for start og ett for slutt. Skriv inn platform-ID fra stoppestedsregisteret.',
  stopPointsMapInfo:
    'Du må legge til minst to stopp; ett for start og ett for slutt.',
  stopPointsInfoFlexibleAreaOnly:
    'Denne typen fleksibel linje tillater kun et fleksibelt stoppested der all ombord- og avstigning skjer.',
  stopPointsInfoMixedFlexible:
    'Legg til en sekvens av minst to faste eller fleksible stopp in den rekkefølgen de passeres.',
  deleteStopPointDialogTitle: 'Slette stoppepunkt',
  deleteStopPointDialogMessage:
    'Er du sikker på at du ønsker å slette dette stoppepunktet?',
  selectCustom: 'Fleksibelt stoppested',
  selectNsr: 'Stoppested',
  editorServiceJourneys: 'Service Journeys',
  newServiceJourneyModalTitle: 'Ny service journey',
  newServiceJourneyModalSubTitle:
    'Fyll in navn, velg journey pattern og trykk deretter Opprett',
  newServiceJourneyModalCancel: 'Avbryt',
  newServiceJourneyModalCreate: 'Opprett',
  newServiceJourneyModalNameLabel: 'Navn',
  newServiceJourneyModalPlaceholder: 'Eks. "Melkeruta ettermiddag"',
  newServiceJourneyModalJourneyPatternLabel: 'Velg journey pattern',
  serviceJourneysInfo:
    'Du kan opprette ulike Service Journeys for ulike åpningstider. For eksempel ett for hverdag og ett for helg.',
  dayTypesEditorSelectLabel: 'Velg kalendere for denne turen',
  dayTypesModalTitle: 'Rediger kalendere',
  dayTypesModalAddNewButtonLabel: 'Legg til kalender',
  dayTypesModalIdHeader: 'NeTEx ID',
  dayTypesModalNameHeader: 'Navn',
  dayTypesModalUsedByHeader: 'I bruk',
  dayTypeNoName: 'Uten navn',
  dayTypeInUse: 'Ja',
  dayTypeNotInUse: 'Nei',
  dayTypeAssignmentAvailableLabel: 'Tilgjengelig',
  dayTypeEditorWeekdays: 'Ukedager for tilgjengelighet',
  weekdaysError: 'Du må fylle ut tilgjengeligheten.',
  dayTypeEditorNameFieldLabel: 'Navn',
  dayTypeEditorNameFieldLabelTooltip:
    'For identifisering av kalender-entiteter i Nplan',
  dayTypeEditorDateAvailability: 'Gyldighet for tilbudet',
  dayTypeEditorDateTooltip: 'Legg til dato for når tilbudet er tilgjengelig',
  dayTypeEditorAddDayTypeAssignment: 'Legg til dato',
  dayTypeEditorNoDayTypeAssignments: 'Ingen datoer er definert.',
  dayTypeEditorDate: 'Dato',
  dayTypeEditorFromAndToDate: 'Bruk fra- og til-dato',
  dayTypeEditorFromDate: 'Fra og med *',
  dayTypeEditorToDate: 'Til og med *',
  dayTypeEditorToDateValidation: 'Minimum en dag etter fra-dato',
  dayTypesEditButton: 'Rediger kalendere',
  deleteDayTypesErrorTitle: 'Feil ved sletting av kalendere',
  deleteSelectedDayTypesButtonLabel: 'Slett markerte kalendere',
  passingTimesEditorError: 'Du må ha gyldige passeringstider.',
  editorAddStopPoint: 'Legg til stopp',
  editorAddServiceJourneys: 'Legg til flere Service Journeys',
  editorAddJourneyPatterns: 'Legg til flere Journey Patterns',
  editorEdit: 'Rediger',
  editorCreate: 'Opprett',
  editorDetailedCreate: 'Opprett {details}',
  stopPointsAtleastTwoPoints: 'Minst to stoppepunkter',
  stopPointsAtleastTwoPointsDetailed:
    'Et journey pattern krever minst to stoppepunkter.',
  generalDescriptionLabel: 'Beskrivelse',
  generalDirectionLabel: 'Retning',
  generalNameLabel: 'Navn *',
  generalPrivateCodeLabel: 'Privat kode',
  generalPrivateCodeLabelTooltip:
    'Privat kode er det som kjennetegner journey patternet internt hos en operatør',
  generalValidationName: 'Navn må fylles inn.',
  tableDeleteConfirmDialogCancelButtonText: 'Nei',
  tableDeleteConfirmDialogConfirmButtonText: 'Ja',
  tableDeleteConfirmDialogMessage:
    'Er du sikker på at du ønsker å slette dette journey patternet?',
  tableDeleteConfirmDialogTitle: 'Slette journey pattern',
  tableDirectionTableHeaderCellLabel: 'Retning',
  tableNameTableHeaderCellLabel: 'Navn',
  tableNewJourneyPatternDefaultText: '- Nytt journey pattern -',
  tableNoJourneyPatternsText: 'Ingen journey patterns.',
  tableServiceJourneysTableHeaderCellLabel: 'Service journeys',
  tableStopPlacesTableHeaderCellLabel: 'Stoppesteder og områder',
  editorJourneyPatternsTabLabel: 'Journey patterns',
  newJourneyPatternModalTitle: 'Nytt journey pattern',
  newJourneyPatternModalSubTitle: 'Fyll inn navn og trykk deretter Opprett',
  newJourneyPatternModalUniqueName: 'Journey patternet må ha et unikt navn',
  newJourneyPatternModalCancel: 'Avbryt',
  newJourneyPatternModalCreate: 'Opprett',
  newJourneyPatternModalLabel: 'Navn *',
  newJourneyPatternModalPlaceholder: 'Eks. "Lokal rute"',
  editorLoadingLineText: 'Laster inn linje',
  editorLoadingNetworkAndStopsText: 'Laster inn nettverk og stoppesteder',
  editorSaveButtonText: 'Lagre',
  editorSaveAndCreateLine: 'Lagre og opprett linjen',
  editorSaveLineLoadingText: 'Lagrer linjen...',
  fixErrorsInTheFollowingSteps: 'Du må rette feil på følgende steg: ',
  navigationNext: 'Neste',
  navigationCancel: 'Avbryt',
  navigationPrevious: 'Forrige',
  linesHeader: 'Linjer',
  flexibleLinesHeader: 'Fleksible linjer',
  labelForAlighting: 'For avstigning',
  labelForBoarding: 'For påstigning',
  labelForBoardingAndAlighting: 'På- og avstigning',
  labelFrontText: 'Fronttekst',
  labelFrontTextRequired: 'Fronttekst *',
  labelBoarding: 'På-/avstigning',
  labelQuayRef: 'Plattform-ID *',
  yes: 'Ja',
  no: 'Nei',
  tableName: 'Navn',
  tableFrontText: 'Fronttekst',
  frontTextTooltip: 'Teksten som skal vises foran på kjøretøyet',
  tableBoarding: 'Påstigning',
  tableAlighting: 'Avstigning',
  tableDefaultValue: '- Nytt stoppepunkt -',
  tableNoStopPoints: 'Ingen stoppepunkter.',
  tableDeleteTitle: 'Slette stoppepunkt',
  tableDeleteMessage:
    'Er du sikker på at du ønsker å slette dette stoppepunktet?',
  flexibleStopPlaceRefAndQuayRefBothValues:
    'Velg enten stoppested eller plattform, ikke begge.',
  flexibleStopPlaceRefAndQuayRefNoValues: 'Du må velge et sted',
  flexibleStopPlaceNoValue: 'Du må velge et stoppested',
  frontTextNoValue: 'Du må oppgi fronttekst',
  frontTextAlighting: 'Første stopp kan kun ha påstigning',
  frontTextBoarding: 'Siste stopp kan kun ha avstigning',
  quayRefInvalid: 'Ugyldig plattform-ID',
  quaySearchResults_loadingLabel: 'Søker...',
  quaySearchResults_quayNotFoundLabel: 'Fant ikke plattform',
  serviceJourneyAvailability: 'Tilgjengelighet',
  serviceJourneyPassingTimes: 'Passeringstider',
  serviceJourneyBusinessHours: 'Åpningstid',
  serviceJourneyMixedFlexiblePassingTimes: 'Passeringstider og tidsvinduer',
  passingTimesInfo: 'Fyll inn passeringstider for de ulike stoppene.',
  passingTimesInfoFlexibleAreasOnly:
    'Fyll inn åpningstiden for det fleksible tilbudet.',
  passingTimesInfoMixedFlexible:
    'Fyll inn passeringstider for faste stopp og tidsvinduer for fleksible områder.',
  serviceJourneyBooking: 'Bestilling',
  generalName: 'Navn *',
  nameIsRequired: 'Navn må fylles inn.',
  generalDescription: 'Beskrivelse',
  generalAvailability: 'Tilgjengelighet',
  generalPrivateCode: 'Privat kode',
  generalPrivateCodeTooltip:
    'Privat kode er det som kjennetegner service journeyen internt hos en operatør',
  generalPublicCode: 'Publikumskode',
  generalPublicCodeTooltip:
    'Publikumskode er det som kjennetegner service journeyen ut mot publikum',
  generalOperator: 'Operatør',
  journeyPatternDeleteDialogTitle: 'Slette journey pattern',
  journeyPatternDeleteDialogMessage:
    'Er du sikker på at du ønsker å slette dette journey patternet?',
  serviceJourneyDeleteTitle: 'Slette service journey',
  serviceJourneydeleteMessage:
    'Er du sikker på at du ønsker å slette denne service journeyen?',
  linesLoadingText: 'Laster inn linjer...',
  linesNameTableHeaderLabel: 'Navn',
  linesNoLinesFoundText: 'Ingen linjer ble funnet.',
  linesOperatorTableHeader: 'Operatør',
  linesBrandingTableHeader: 'Merkevare',
  linesPublicCodeTableHeaderLabel: 'Publikumskode',
  linesPrivateCodeTableHeaderLabel: 'Privat kode',
  nameEmpty: 'Navn må fylles inn.',
  publicCodeEmpty: 'Publikumskode må fylles inn.',
  networkRefEmpty: 'Du må velge et nettverk.',
  operatorRefEmpty: 'Du må velge en operatør.',
  transportModeEmpty: 'Du må velge en transportgruppe.',
  transportSubModeEmpty: 'Du må velge en transportundergruppe.',
  flexibleLineTypeEmpty: 'Du må velge en type.',
  homePage: 'Startsiden',
  networkAuthorityMissing: 'Nettverk mangler',
  networkAuthorityMissingDetails:
    'Det finnes ingen autoriteter for denne dataleverandøren. Vennligst ta kontakt med administratorene for å opprette dette.',
  networksAuthorityTableHeaderLabel: 'Autoritet',
  editorNetworkAuthorityLabelText: 'Autoritet *',
  editorCreateNetworkHeaderText: 'Opprett nettverk',
  editorNetworkDescription:
    'Minst ett nettverk er påkrevd. Nettverk kan brukes til å gruppere linjer.',
  editorNetworkValidationAuthority: 'Autoritet må velges',
  editorNetworkValidationName: 'Navn må fylles inn',
  delete: 'Slett',
  editorDeleteNetworkConfirmDialogCancelText: 'Nei',
  editorDeleteNetworkConfirmDialogConfirmText: 'Ja',
  editorDeleteNetworkConfirmDialogMessage:
    'Er du sikker på at du ønsker å slette dette nettverket?',
  editorDeleteNetworkConfirmDialogTitle: 'Slette nettverk',
  editorDeletingNetworkLoadingText: 'Sletter nettverket...',
  editorNetworkDescriptionLabelText: 'Beskrivelse',
  editorEditNetworkHeaderText: 'Rediger nettverk',
  editorLoadingNetworkText: 'Laster inn nettverket...',
  editorNetworkNameLabelText: 'Navn *',
  editorNetworkPrivateCodeLabelText: 'Privat kode',
  save: 'Lagre',
  editorSavingNetworkLoadingText: 'Lagrer nettverket...',
  network: 'nettverk',
  networksHeaderText: 'Nettverk',
  networksLoadingNetworksText: 'Laster inn nettverk...',
  networksNameTableHeaderLabel: 'Navn',
  networksNoNetworksFoundText: 'Ingen nettverk ble funnet',
  networksPrivateCodeTableHeaderLabel: 'Privat kode',
  networksLoadNetworksErrorHeader: 'Laste nettverk',
  networksLoadNetworksErrorMessage:
    'En feil oppstod under lastingen av nettverkene: {details}',
  networksLoadNetworkByIdErrorHeader: 'Laste nettverk',
  networksLoadNetworkByIdErrorMessage:
    'En feil oppstod under lastingen av nettverket: {details}',
  networksSaveNetworkSuccessHeader: 'Lagre nettverk',
  networksSaveNetworkSuccessMessage: 'Nettverket ble lagret.',
  networksSaveNetworkErrorHeader: 'Lagre nettverk',
  networksSaveNetworkErrorMessage:
    'En feil oppstod under lagringen av nettverket: {details}',
  networksDeleteNetworkSuccessHeader: 'Slette nettverk',
  networksDeleteNetworkSuccessMessage: 'Nettverket ble slettet.',
  networksDeleteNetworkErrorHeader: 'Slette nettverk',
  networksDeleteNetworkErrorMessage:
    'En feil oppstod under slettingen av nettverket: {details}',
  branding: 'merkevare',
  brandingsHeaderText: 'Merkevarer',
  brandingsLoadingBrandingsText: 'Laster inn merkevarer...',
  brandingsNameTableHeaderLabel: 'Navn',
  brandingsNoBrandingsFoundText: 'Ingen merkevarer ble funnet',
  brandingsShortNameTableHeaderLabel: 'Kort navn',
  brandingsDescriptionTableHeaderLabel: 'Beskrivelse',
  brandingsUrlTableHeaderLabel: 'URL',
  brandingsImageUrlTableHeaderLabel: 'Bilde URL',
  editorCreateBrandingHeaderText: 'Opprett merkevare',
  editorBrandingDescription:
    'Merkevarer kan brukes til å legge ditt eget merkevare til linjer og nettverk.',
  editorBrandingNameLabelText: 'Navn *',
  editorBrandingShortNameLabelText: 'Kort navn',
  editorBrandingDescriptionLabelText: 'Beskrivelse',
  editorBrandingUrlLabelText: 'URL',
  editorBrandingImageUrlLabelText: 'Bilde URL',
  editorBrandingValidationName: 'Navn må fylles inn',
  editorDeleteBrandingConfirmDialogTitle: 'Slette merkevare',
  editorDeleteBrandingConfirmDialogMessage:
    'Er du sikker på at du ønsker å slette denne merkevaren?',
  editorEditBrandingHeaderText: 'Rediger merkevare',
  editorDeleteBrandingConfirmDialogCancelText: 'Nei',
  editorDeleteBrandingConfirmDialogConfirmText: 'Ja',
  editorDeleteBrandingConfirmationDialogTitle: 'Slette merkevare',
  editorDeleteBrandingConfirmationDialogMessage:
    'Er du sikker på at du ønsker å slette denne merkevaren?',
  brandingsDropdownLabelText: 'Merkevare',
  brandingsLoadBrandingsErrorHeader: 'Laste merkevarer',
  brandingsLoadBrandingsErrorMessage:
    'En feil oppstod under lastingen av merkevarene: {details}',
  brandingsLoadBrandingByIdErrorHeader: 'Laste merkevare',
  brandingsLoadBrandingByIdErrorMessage:
    'En feil oppstod under lastingen av merkevaren: {details}',
  brandingsSaveBrandingSuccessHeader: 'Lagre merkevare',
  brandingsSaveBrandingSuccessMessage: 'Merkevaren ble lagret.',
  brandingsSaveBrandingErrorHeader: 'Lagre merkevare',
  brandingsSaveBrandingErrorMessage:
    'En feil oppstod under lagringen av merkevaren: {details}',
  brandingsDeleteBrandingSuccessHeader: 'Slette merkevare',
  brandingsDeleteBrandingSuccessMessage: 'Merkevaren ble slettet.',
  brandingsDeleteBrandingErrorHeader: 'Slette merkevare',
  brandingsDeleteBrandingErrorMessage:
    'En feil oppstod under slettingen av merkevaren: {details}',
  editorSavingBrandingLoadingText: 'Lagrer merkevaren...',
  editorDeletingBrandingLoadingText: 'Sletter merkevaren...',
  editorLoadingBrandingText: 'Laster inn merkevaren...',
  stopPlacesCreateStopPlaceLinkIconLabelText: 'Opprett fleksibelt stoppested',
  editorDescription:
    'Fyll inn liste med koordinater på GeoJSON-format, eller klikk i kartet for å opprette polygon.',
  editorCreateHeader: 'Opprett fleksibelt stoppested',
  editorDeleteStopPlaceDialogCancelButtonText: 'Nei',
  editorDeleteStopPlaceDialogConfirmButtonText: 'Ja',
  editorDeleteStopPlaceDialogMessage:
    'Er du sikker på at du ønsker å slette dette stoppestedet?',
  editorDeleteStopPlaceDialogTitle: 'Slette stoppested',
  editorDeletingOverlayLoaderText: 'Sletter stoppestedet...',
  editorDescriptionFormLabelText: 'Beskrivelse',
  editorEditHeader: 'Rediger fleksibelt stoppested',
  errorCoordinates: 'Koordinatene er ikke på rett format',
  errorCoordinatesEmpty: 'Ingen koordinater oppgitt',
  errorCoordinatesSelfIntersecting:
    'Polygonkantene krysser hverandre. Juster formen slik at ingen kanter krysser.',
  errorCoordinatesSelfIntersectingCount:
    'Polygonet har {count} selvkryssing(er)',
  editorLoadingDependenciesText: 'Laster inn avhengigheter',
  editorLoadingStopPlaceText: 'Laster inn stoppestedet',
  editorNameFormLabelText: 'Navn *',
  editorPrivateCodeFormLabelText: 'Privat kode',
  editorCoordinatesFormLabelText:
    'Koordinater i GeoJson-rekkefølge [Long, Lat]',
  editorDrawPolygonButtonText: 'Tegn koordinater i kart',
  editorSavingOverlayLoaderText: 'Lagrer stoppestedet...',
  validateFormErrorFlexibleAreaNotEnoughPolygons:
    'Du må legge til flere punkter i kartet',
  validateFormErrorNameEmpty: 'Du må gi stoppestedet et navn',
  validateFormErrorFlexibleStopPlaceType:
    'Du må gi stoppestedet eller hvert område en type',
  stopPlaceText: 'fleksibelt stoppested',
  stopPlace: 'Fleksibelt stoppested *',
  stopPlacesHeader: 'Fleksible stoppesteder',
  stopPlacesLoadingStopPlacesText: 'Laster inn stoppesteder...',
  stopPlacesNameTableHeaderLabelText: 'Navn',
  stopPlacesNoStopPlacesFoundText: 'Ingen stoppesteder ble funnet.',
  stopPlacesNumberOfAreasTableHeaderLabelText: 'Antall områder',
  stopPlacesPrivateCodeTableHeaderLabelText: 'Privat kode',
  stopPlaceAreaLabelPrefix: 'Område',
  stopPlaceAddAreaButtonLabel: 'Legg til område',
  stopPlaceRemoveAreaButtonLabel: 'Ta bort område',
  passingTimesTypeFixed: 'Faste',
  passingTimesTypeFlexible: 'Fleksible',
  passingTimesArrivalTime: 'Ankomsttid',
  passingTimesDepartureTime: 'Avgangstid',
  passingTimesLatestArrivalTime: 'Slutt',
  passingTimesEarliestDepartureTime: 'Start',
  passingTimesDayOffset: 'Døgnskille',
  passingTimesDayOffsetTooltip:
    'Sett døgnskille dersom passeringstiden er én eller flere dager senere enn tilbudets avreise',
  errorAllPassingTimesMustBeFilled: 'Alle passeringstidene må være fylt ut.',
  errorDepartureAfterArrival: 'Avgangstid kan ikke være før ankomsttid.',
  errorDepartureAfterEarliest:
    'Avgangstid kan ikke være før tidligst avgangstid.',
  errorArrivalBeforeLatest:
    'Ankomsttid ikke kan være senere enn senest ankomsttid.',
  errorLaterThanPrevious:
    'Tidspunktene må være senere enn forrige stoppesteds tidspunkt.',
  errorLastArrivalMustBeSet:
    'Ankomsttid eller seneste ankomsttid for siste stoppested må være satt.',
  errorStopPoints: 'Du må opprette minst to stoppepunkter.',
  errorARowIsMissingData: 'Minst èn av radene mangler tidspunkter.',
  weekdaysMonday: 'Mandag',
  weekdaysTuesday: 'Tirsdag',
  weekdaysWednesday: 'Onsdag',
  weekdaysThursday: 'Torsdag',
  weekdaysFriday: 'Fredag',
  weekdaysSaturday: 'Lørdag',
  weekdaysSunday: 'Søndag',
  requiredInputMarker: 'Feltene markert med * er obligatoriske',
  air: 'Luftfartøyer',
  bus: 'Buss',
  cableway: 'Taubane',
  coach: 'Ekspressbuss',
  funicular: 'Bergbane',
  metro: 'T-bane eller metro',
  rail: 'Tog',
  tram: 'Bane',
  water: 'Vannfartøyer',
  taxi: 'Taxi',
  snowAndIce: 'Snø og is',
  domesticFlight: 'Innenriksflyrute',
  helicopterService: 'Helikopterrute',
  internationalFlight: 'Internasjonalflyrute',
  airportLinkBus: 'Flybuss',
  expressBus: 'Ekspressrute',
  localBus: 'Lokalbuss',
  nightBus: 'Nattbuss',
  railReplacementBus: 'Erstatningsbuss',
  regionalBus: 'Regional bussrute',
  schoolBus: 'Skolebuss',
  shuttleBus: 'Shuttlebuss',
  sightseeingBus: 'Turistbuss',
  sightseeingService: 'Turistbåtrute',
  telecabin: 'Taubane',
  internationalCoach: 'Internasjonal ekspressbuss',
  nationalCoach: 'Ekspressbuss',
  touristCoach: 'Turistbuss',
  airportLinkRail: 'Flytog',
  international: 'Internationalt tog',
  interregionalRail: 'Regiontog (DT)',
  local: 'Lokaltog (LT)',
  longDistance: 'Intercity (IC)',
  nightRail: 'Nattog (NT)',
  regionalRail: 'Regiontog (RT)',
  touristRailway: 'Museumstog',
  cityTram: 'Bybane',
  localTram: 'Sporvogn eller trikk',
  highSpeedPassengerService: 'Hurtigbåt',
  highSpeedVehicleService: 'Kombibåt eller bilførende hurtigbåt',
  internationalCarFerry: 'Internasjonal bilferje',
  internationalPassengerFerry: 'Internasjonal passasjerbåt',
  localCarFerry: 'Innenriks bilferje',
  localPassengerFerry: 'Innenriks passasjerbåt',
  nationalCarFerry: 'Hurtigruten',
  charterTaxi: 'Taxi',
  communalTaxi: 'Rutegående taxi',
  waterTaxi: 'Båttaxi',
  snowCoach: 'Beltebuss',
  timeUnitPickerYearsLabel: 'År',
  timeUnitPickerMonthsLabel: 'Måneder',
  timeUnitPickerDaysLabel: 'Dager',
  timeUnitPickerHoursLabel: 'Timer',
  timeUnitPickerMinutesLabel: 'Minutter',
  timeUnitPickerSecondsLabel: 'Sekunder',
  timeUnitPickerResetLabel: 'Nullstill',
  timeUnitPickerDoneLabel: 'Ferdig',
  copyServiceJourneyDialogTitle: 'Kopiér Service Journey',
  copyServiceJourneyDialogNameTemplateLabel: 'Navnmal',
  copyServiceJourneyDialogDepartureTimeLabel: 'Avgangstid',
  copyServiceJourneyDialogLatestPossibleDepartureTimelabel:
    'Siste mulige avgangstid',
  copyServiceJourneyDialogCancelButtonText: 'Avbryt',
  copyServiceJourneyDialogSaveButtonText: 'Lag kopier',
  copyServiceJourneyDialogValidationUntilTimeBeforeInitialTimeError:
    'Siste mulige avgangstid kan ikke være før første avgangstid.',
  copyServiceJourneyDialogMultipleSwitchLabel: 'Lag flere kopier',
  copyServiceJourneyDialogIntervalLabel: 'Velg intervall',
  noticesHeader: 'Notices',
  newNoticeLabel: 'Ny notice',
  deleteNoticeTooltip: 'Slett notice',
  addNoticeTooltip: 'Legg til notice',
  flexibleStopAreaType: 'Stoppestedstype',
  flexibleStopAreaTypeNotSet: 'Ikke valgt',
  flexibleStopAreaTypeMixed: 'Blandet',
  flexibleStopAreaTypeUnrestrictedRoadNetwork: 'Hvor som helst i polygonet',
  flexibleStopAreaTypeUnrestrictedPublicTransportAreas:
    'Kun på stoppesteder i polygonet',
  openBulkDeleteDialogButtonLabel: 'Slett flere',
  bulkDeleteDialogTitle: 'Slett flere',
  bulkDeleteDialogFilterSearchLabel: 'Søk på Navn',
  bulkDeleteDialogNameHeader: 'Navn',
  bulkDeleteDialogDepartureHeader: 'Avgangstid',
  bulkDeleteDialogDepartureDayOffsetHeader: 'Døgnskille',
  bulkDeleteDialogValidityHeader: 'Gyldighet',
  bulkDeleteDialogCancelButtonLabel: 'Avbryt',
  bulkDeleteDialogConfirmButtonLabel: 'Slett',
  dayTypesValidationError:
    'Minst en gyldighetsperiode har ingen tilgjengelig ukedag',
  provider: 'dataleverandør',
  providersHeaderText: 'Dataleverandører',
  createProviderHeaderText: 'Opprett dataleverandør',
  providersLoading: 'Laster dataleverandører',
  navBarProvidersMenuItemLabel: 'Dataleverandører',
  providersNameTableHeaderLabel: 'Navn',
  providersCodeTableHeaderLabel: 'Kode',
  providersCodespaceXmlnsHeaderLabel: 'XML navneområde',
  providersCodespaceXmlnsUrlHeaderLabel: 'XML navneområde url',
  editorEditProviderHeaderText: 'Rediger dataleverandør',
  editorCreateProviderHeaderText: 'Opprett dataleverandør',
  editorProviderNameLabelText: 'Navn',
  editorProviderCodeLabelText: 'Kode',
  editorProviderCodespaceXmlnsLabelText: 'XML navneområde',
  editorProviderCodespaceXmlnsUrlLabelText: 'XML navneområde url',
  editorProviderValidationField: 'Navn er obligatorisk',
  editorSavingProviderLoadingText: 'Lagrer dataleverandør...',
  editorLoadingProviderText: 'Laster dataleverandør',
  saveProviderError: 'Feil ved lagring av dataleverandør',
  saveProviderErrorFallback: 'Ukjent feil ved lagring av dataleverandør',
  noProvidersDescriptionText:
    'Din Nplan-installasjon trenger minst en dataleverandør',
  landingPageNotLoggedIn: 'Ikke logget inn',
  landingPageLoginButtonText: 'Logg inn',
  showQuays: 'Vis quayer',
  hideQuays: 'Skjul quayer',
  oneQuay: '1 quay',
  numberOfQuays: '{count} quayer',
  addToJourneyPattern: 'Legg til',
  showNonSelectedQuays: 'Vis ikke valgte quayer',
  hideNonSelectedQuays: 'Skjul ikke valgte quayer',
  quayOrder: 'Rekkefølge',
  mapSearchInProgress: 'Søker...',
  mapSearchNoResults: 'Ingen resultater funnet',
  mapSearchResults: 'Resultater:',
  mapSearchPlaceholder: 'Stoppested etter ID, navn eller plattform-ID',
  mapLoadingStopsDataText: 'Laster inn stopper...',
  locateStopPoint: 'Vis',
  locateStopPointTooltip: 'Vis på kartet',
  dropdownNoMatchesText: 'Ingen tilgjengelige valg',
  exportsDownloadUnsupportedBrowserTitle: 'Nettleser ikke støttet',
  exportsDownloadUnsupportedBrowserMessage:
    'Beklager, nettleseren din støtter ikke filnedlastinger.',
  exportsDownloadErrorTitle: 'Nedlasting mislyktes',
  exportsDownloadErrorMessage:
    'Det oppstod en feil under nedlasting av eksporten. Vennligst prøv igjen.',
  selectAll: 'Velg alle',
  clearAll: 'Fjern valgte',
  clearSelected: 'Fjern valgt',
  copyJourneyPatternDialogTitle: 'Kopiér Journey Pattern',
  copyJourneyPatternDialogNameTemplateLabel: 'Navnmal *',
  copyJourneyPatternDialogCancelButtonText: 'Avbryt',
  copyJourneyPatternDialogSaveButtonText: 'Lag kopi',
  copyInstance: 'en kopi',
  journeyPatternDuplicateNameValidationError:
    'Journey patternet må ha et unikt navn',

  // Day Types - Navigation
  navBarDayTypesMenuItemLabel: 'Kalendere',

  // Day Types - List page
  dayTypesHeaderText: 'Kalendere',
  dayTypesCreateDayTypeButtonLabel: 'Opprett kalender',
  dayTypesLoadingText: 'Laster kalendere...',
  dayTypesNameTableHeader: 'Navn',
  dayTypesWeekdaysTableHeader: 'Ukedager',
  dayTypesInUseTableHeader: 'I bruk',
  dayTypesNoDayTypesFoundText: 'Ingen kalendere funnet.',
  dayTypesDeleteConfirmDialogTitle: 'Slett kalender',
  dayTypesDeleteConfirmDialogMessage:
    'Er du sikker på at du vil slette denne kalenderen?',

  // Day Types - Editor page
  dayTypesCreateDayTypeHeader: 'Opprett kalender',
  dayTypesEditDayTypeHeader: 'Rediger kalender',
  dayTypesEditorDescription:
    'Kalendere definerer når tjenester er tilgjengelige. Velg ukedager og datoperioder for tjenestens tilgjengelighet.',
  dayTypesSavingDayTypeText: 'Lagrer kalender...',
  dayTypesDeletingDayTypeText: 'Sletter kalender...',
  dayTypesLoadingDayTypeText: 'Laster kalender...',
  dayType: 'kalender',

  // Day Types - Notifications
  dayTypesLoadDayTypesErrorTitle: 'Laste kalendere',
  dayTypesLoadDayTypeErrorTitle: 'Laste kalender',
  dayTypesSaveDayTypeSuccessTitle: 'Lagre kalender',
  dayTypesSaveDayTypeSuccessMessage: 'Kalenderen ble lagret.',
  dayTypesSaveDayTypeErrorTitle: 'Lagre kalender',
  dayTypesDeleteDayTypeSuccessTitle: 'Slette kalender',
  dayTypesDeleteDayTypeSuccessMessage: 'Kalenderen ble slettet.',
  dayTypesDeleteDayTypeErrorTitle: 'Slette kalender',

  // Duration
  'duration.hours': '{hours} timer',
};
